import { ILadder, ILeagueContestants, IInstantChallenger, IMatchMaker, IChallenge, IContestant } from "../../typings/typings";
import { Base } from "../config/contestant_state/Base";
import { League } from "./League";

export class Ladder extends League implements ILadder {
    public contestants: ILeagueContestants;
    public instantChallenger: IInstantChallenger;
    public matchmaker: IMatchMaker;
    public challenge: IChallenge;
    public recentResultsCount;
    public upcomingMatchesStates;
    public state: string;

    constructor(jsonData) {
        super(jsonData);
        this.state = jsonData.state;
        this.contestants = jsonData.contestants;
        this.instantChallenger = jsonData.instantChallenger;
        this.matchmaker = jsonData.matchmaker;
        this.challenge = jsonData.challenge;
        this.upcomingMatchesStates = { open: 100, challenge: 100, protest: 0 };
        this.recentResultsCount = { closed: 6, protest: 0 }; // request 5+1 to check if we need to show the more results link
    }

    public setCurrentContestant(contestant: IContestant) {
        this.currentContestant = contestant;
        let base = new Base();

        if (contestant.state == base.CONTESTANT_STATE_CHECKED_IN) {
            this.currentContestant.state = base.CONTESTANT_STATE_PLAYING;
        }

        if (contestant.state == base.CONTESTANT_STATE_FINISHED) {
            this.currentContestant.state = base.CONTESTANT_STATE_NOT_SIGNED_UP;
        }

        if (contestant.state == base.CONTESTANT_STATE_SIGNED_UP) {
            this.currentContestant.state = base.CONTESTANT_STATE_NOT_SIGNED_UP;
        }
    }

    public getNextDate(): Date {
        return null;
    }

    public getSecondsUntilNextUpdate(): number {
        return 0;
    }

    public hasCountDown(): boolean {
        return false;
    }

    public getUrlByTemplate(template: string, $filter, $scope) {
        switch (template) {
            case "Header":
                return $filter("sprintf")($scope.templateUrls.templateHeaderUrl, "ladder");
            case "ChallengeType":
                return $filter("sprintf")($scope.templateUrls.templateChallengeTypesUrl, "ladder");
            case "Match":
                return $filter("sprintf")($scope.templateUrls.templateMatchUrl, "ladder");
            case "Result":
                return $filter("sprintf")($scope.templateUrls.templateResultUrl, "ladder");
            case "Information":
                return $filter("sprintf")($scope.templateUrls.templateInformationUrl, "ladder");
            default:
                return super.getUrlByTemplate(template, $filter, $scope);
        }
    }

    public isInstantChallengerActive(): boolean {
        return true;
    }

    public getInstantChallengerInfo(): any {
        return this.instantChallenger;
    }

    /**
     * Return the current league-state
     *
     * @return The league-state
     */
    public getState(): string {
        if (this.state === "finished") {
            return "finished";
        } else if (this.isContestantNotSignedUp() || this.isContestantFinished()) {
            return "signUp";
        } else {
            return "inProgress";
        }
    }
}
